import request from '@/utils/server'

// 获取维保记录
export function getMaintenanceList(query) {
    return request({
      url: '/device/getMaintenanceList',
        method: 'get',
      params: query
    })
  }
  // 删除维保记录

  export function delMaintenance(data) {
    return request({
      url: '/device/delMaintenance',
        method: 'POST',
      data:data
    })
  }